<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :color='matchLevel.color'
        v-bind="attrs"
        v-on="on"
      >
        {{ matchLevel.icon }}
      </v-icon>
    </template>
    <span>{{ matchLevel.text }}</span>
  </v-tooltip>
</template>

<script>
import { checkPartNumberMatching } from '@/helpers/prices'

export default {
  props: ['partNumber', 'query'],
  computed: {
    matchLevel () {
      let color = ''
      let icon = ''
      let text = ''

      switch (checkPartNumberMatching(this.partNumber, this.query).match) {
        case 'exact':
          color = 'success'
          icon = 'mdi-check-circle'
          text = 'Exact match'
          break
        case 'start':
          color = 'warning'
          icon = 'mdi-circle-slice-5'
          text = 'Start by the request'
          break
        case 'contain':
          color = 'warning'
          icon = 'mdi-circle-slice-3'
          text = 'Contain the request'
          break
        default:
          color = 'error'
          icon = 'mdi-circle-outline'
          text = 'Do not math the request'
          break
      }
      return { color, icon, text }
    }
  }
}
</script>
